export default __webpack_public_path__ + "257e74e759387909c7e1ace226e48704.png";